import commonService from "./common.service";

const p2pNavigationService = {
  getContext: () => commonService.get("/p2p/navigation-context"),
  getAccessDiagnostics: () => commonService.get("/p2p/diagnostics/access"),
  listCategories: () => commonService.get("/p2p/categories"),
};

export default p2pNavigationService;
